<template>
  <div>
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>
      <div class="row">
        <v-form-group :validator="$v.labcorp.dateCollected"
                      label="Date Collected"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <date-picker :disabled="onlyView"
                       v-model="labcorp.dateCollected"
                       slot-scope="{ attrs, listeners }"
                       placeholder="Date Collected"
                       v-bind="attrs"
                       v-on="listeners" />
        </v-form-group>
        <v-form-group :validator="$v.labcorp.dateReceived"
                      label="Date Received"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <date-picker :disabled="onlyView"
                       v-model="labcorp.dateReceived"
                       slot-scope="{ attrs, listeners }"
                       v-bind="attrs"
                       v-on="listeners"
                       placeholder="Date Received" />
        </v-form-group>
        <v-form-group :validator="$v.labcorp.dateReported"
                      label="Date Reported"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <date-picker :disabled="onlyView"
                       v-model="labcorp.dateReported"
                       slot-scope="{ attrs, listeners }"
                       v-bind="attrs"
                       v-on="listeners"
                       placeholder="Date Reported" />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.ldlp"
                      label="LDL-P"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.ldlp"
                        placeholder="LDL-P"
                        min=300
                        max=3600 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.ldlc"
                      label="LDL-C"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.ldlc"
                        placeholder="LDL-C"
                        min=0
                        max=1300 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.hdlc"
                      label="HDL-C"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.hdlc"
                        placeholder="HDL-C"
                        min=20
                        max=150 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.triglycerides"
                      label="Triglycerides"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.triglycerides"
                        placeholder="Triglycerides"
                        min=5
                        max=10000 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.cholesterol"
                      label="Cholesterol"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.cholesterol"
                        placeholder="Cholesterol"
                        min=20
                        max=1000 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.hdlp"
                      label="HDL-P"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.hdlp"
                        placeholder="HDL-P"
                        min=18
                        max=50 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.smallLDLP"
                      label="Small LDL-P"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.smallLDLP"
                        placeholder="Small LDL-P"
                        min=0
                        max=2800 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.sizeLDL"
                      label="LDL Size"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.sizeLDL"
                        placeholder="LDL Size"
                        min=18
                        max=30 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.insulinResistance"
                      label="Score LP-IR"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.insulinResistance"
                        placeholder="Score LP-IR"
                        min=20
                        max=100 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.glucose"
                      label="Fasting Glucose"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.glucose"
                        placeholder="Fasting Glucose"
                        min=30
                        max=800 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.bun"
                      label="BUN"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.bun"
                        placeholder="BUN"
                        min=1
                        max=150 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.creatinine"
                      label="Creatinine"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.creatinine"
                        placeholder="Creatinine"
                        min=0.1
                        max=20 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.egfr"
                      label="eGFR"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.egfr"
                        placeholder="eGFR"
                        min=15
                        max=140 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.bunCreatinineRatio"
                      label="BUN/Creatinine Ratio"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.bunCreatinineRatio"
                        placeholder="BUN/Creatinine Ratio"
                        min=1
                        max=100 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.sodium"
                      label="Sodium"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.sodium"
                        placeholder="Sodium"
                        min=90
                        max=220 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.potassium"
                      label="Potassium"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.potassium"
                        placeholder="Potassium"
                        min=1.0
                        max=10 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.chloride"
                      label="Chloride"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.chloride"
                        placeholder="Chloride"
                        min=50
                        max=140 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.carbonDioxide"
                      label="Carbon Dioxide"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.carbonDioxide"
                        placeholder="Carbon Dioxide"
                        min=3
                        max=60 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.calcium"
                      label="Calcium"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.01
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.calcium"
                        placeholder="Calcium"
                        min=3.0
                        max=25 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.a1C"
                      label="A1C"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        step=0.1
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.a1C"
                        placeholder="A1C"
                        min=1
                        max=25 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.lpa"
                      label="Lp(a)"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.lpa"
                        placeholder="Lp(a)"
                        min="0"
                        max="600"
                        step="0.1" />
        </v-form-group>

        <v-form-group label="TSH"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.tsh"
                        placeholder="TSH"
                        step="0.001"
                        min=0 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.glycA"
                      label="Glyc A"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        type="number"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.glycA"
                        placeholder="Glyc A"
                        min=0
                        max=800 />
        </v-form-group>

        <v-form-group :validator="$v.labcorp.mrn"
                      label="Patient Id"
                      class="col-12 col-md-6 col-lg-6 col-xl-4">
          <b-form-input :disabled="onlyView"
                        slot-scope="{ attrs, listeners }"
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="labcorp.mrn"
                        placeholder="Patient Id" />
        </v-form-group>
      </div>
      <b-form-group class="form-buttons">
        <b-btn variant="success" type="submit" :disabled="onlyView">Generate Final Report</b-btn>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
  import { required, requiredIf, between } from "vuelidate/lib/validators";
  import formMixin from 'mixins/form-mixin';
  import finalReportFormMixin from 'mixins/final-report-form-mixin';

  export default {
    mixins: [formMixin, finalReportFormMixin],

    validations: {
      labcorp: {
        dateCollected: { required },
        dateReceived: { required },
        dateReported: { required },
        ldlp: { required, between: between(300, 3600) },
        ldlc: { required, between: between(0, 1300) },
        hdlc: { required, between: between(20, 150) },
        triglycerides: { required, between: between(5, 10000) },
        cholesterol: { required, between: between(20, 1000) },
        hdlp: { required, between: between(18, 50) },
        smallLDLP: { required, between: between(0, 2800) },
        sizeLDL: { required, between: between(18, 30) },
        glucose: { required, between: between(30, 800) },
        bun: { between: between(1, 150) },
        creatinine: { between: between(0, 20) },
        egfr: { required, between: between(15, 140) },
        bunCreatinineRatio: { between: between(1, 100) },
        sodium: { between: between(90, 220) },
        potassium: { between: between(1, 10) },
        chloride: { between: between(50, 140) },
        carbonDioxide: { between: between(3, 60) },
        calcium: { between: between(3, 25) },
        insulinResistance: { required, between: between(20, 100) },
        glycA: { required, between: between(0, 800) },
        lpa: { required: requiredIf(function () { return this.report.type.startsWith("Cardiometabolic") }), between: between(0, 600) },
        a1C: { between: between(3, 15) }
      }
    }
  };
</script>